import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "places-top-matter" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "right-actions" }

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import NcActions from '@nextcloud/vue/components/NcActions';
import NcActionButton from '@nextcloud/vue/components/NcActionButton';

import { t } from '@services/l10n';
import { useRouteIs } from '@services/route-is';
import { routes } from '@services/router';
import * as strings from '@services/strings';
import * as utils from '@services/utils/common';
import { constants } from '@services/constants';

import BackIcon from 'vue-material-design-icons/ArrowLeft.vue';
import UnassignedIcon from 'vue-material-design-icons/MapMarkerOff.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'PlacesTopMatter',
},
  __name: 'PlacesTopMatter',
  setup(__props) {



const route = useRoute();
const router = useRouter();
const routeIs = useRouteIs();
const viewname = computed((): string => {
  return strings.viewName(route);
});

const name = computed((): string | null => {
  if (routeIs.PlacesUnassigned) {
    return t('memories', 'Unidentified location');
  }

  return utils.routeParamToString(route.params.name).split('-').slice(1).join('-');
});

function back() {
  router.go(-1);
}

function openUnassigned() {
  router.push({
    name: routes.Places.name,
    params: {
      name: constants.PLACES_NULL,
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (name.value)
      ? (_openBlock(), _createBlock(_unref(NcActions), { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_unref(NcActionButton), {
              "aria-label": _unref(t)('memories', 'Back'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
            }, {
              icon: _withCtx(() => [
                _createVNode(BackIcon, { size: 20 })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('memories', 'Back')) + " ", 1)
              ]),
              _: 1
            }, 8, ["aria-label"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(name.value || viewname.value), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(NcActions), { inline: 0 }, {
        default: _withCtx(() => [
          (!name.value && !_unref(routeIs).PlacesUnassigned)
            ? (_openBlock(), _createBlock(_unref(NcActionButton), {
                key: 0,
                "aria-label": _unref(t)('memories', 'Files without location'),
                onClick: openUnassigned,
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(UnassignedIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('memories', 'Files without location')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})